import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import "@/index.css";
import App from "@/App";

axios.defaults.withCredentials = true;

const rootElement = document.getElementById("root");
createRoot(rootElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
